import angular from 'angular';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'CategoryService',
  '$state',
  '$rootScope',
  'SharedService',
  '$stateParams',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  'SalesService',
  '$filter',
  'ngAuthSettings'
];

class SalesController{
  constructor ($scope,
               CategoryService,
               $state,
               $rootScope,
               SharedService,
               $stateParams,
               $uibModal,
               $timeout,
               Pagination,
               SessionService,
               SalesService,
               $filter,
               ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.Pagination = Pagination;
    this.SessionService = SessionService;
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.CategoryService = CategoryService;
    this.$timeout = $timeout;
    this.SharedService = SharedService;
    this.SalesService = SalesService;
    this.$filter = $filter;
    this.loanding = false;
    this.pagerCategories = [];
    this.itemsPerPage = 12;
    this.loadingCategories = true;
    this.productsList = [];
    this.productHighPriceTest = 0;
    this.productLowPriceTest = 0;
    this.loadingProducts = false;
    this.pageSize = 24;
    this.currentPage = 1;
    this.totalItems = 1;
    this.controlPrice = 0;
    this.sortType = 1;
    this.searchText = '';
    this.typeview = 1;
    this.dataFilter = {};
    this.localFilters = null;
    
    this.ctrlTest = 3;
    this.initializeTest = false;
    
    this.customFilters = {
      productHighPrice : null,
      productLowPrice : null,
      productHighPriceTest : null,
      productLowPriceTest : null
    };
  }
  
  $onInit(){
    this.getProducts();
  }
  
  confirmTimerTest() {
    this.$timeout(() =>{
      this.timerTest();
    }, 1000);
  }
  
  timerTest() {
    if(this.ctrlTest > 0) {
      this.ctrlTest--;
      this.confirmTimerTest();
    }
    else {
      this.getProducts();
      this.initializeTest = false;
    }
  }
  
  onChangePriceFilter (){
    if(this.initializeTest) this.ctrlTest = 3;
    else {
      this.initializeTest = true;
      this.timerTest();
    }
  };
  
  /**
   Get current category
   @method getCurrentCategory
   */
  
  getProducts(footer, cleanFilter, footerPlace) {
    if(this.loadingProducts) return;
    this.loadingProducts = true;
    this.searchText = '';
    let userId = '';
    try{ userId = this.shCtrl.globals.currentUser.userId; }
    catch(e){}
    if(footer){
      this.scrollProductListToTop();
    }
    let data = {
      pageSize : this.pageSize,
      pageNumber : this.currentPage,
      internSearchText : this.searchText,
      userId : userId,
      offers : 1,
      filters : {
        productHighPrice : (cleanFilter ? 0 : this.customFilters.productHighPriceTest),
        productLowPrice : (cleanFilter ? 0 : this.customFilters.productLowPriceTest),
        sort : this.sortType
      }
    };
    this.SalesService.getProducts(data).then(response => {
      this.pageSize = (this.pageSize > response.cantidadTotal ? 24 : this.pageSize);
      this.totalItems = angular.copy(response.cantidadTotal);
      this.totalPages = angular.copy(response.totalPage);
      
      if(response.items.length){
        if(!this.controlPrice){
          this.customFilters.productHighPriceTest = response.highestPrice;
          this.customFilters.productLowPriceTest = 0;
          this.controlPrice++;
        }
        this.customFilters.productHighPrice = response.highestPrice;
        this.customFilters.productLowPrice = response.lowestPrice;
        this.dataFilter = {};
        this.productsList = angular.copy(response.items);
        this.loadingProducts = false;
        this.activateProducts(this.customFilters);
        let resultView = this.SessionService.get('itemsView');
        if(!resultView){
          if($(window).width() >= 1200) {
            this.setCookieItemsView(this.shCtrl.globalParams.itemsView.pc);
          }else if($(window).width() < 1200) {
            this.setCookieItemsView(this.shCtrl.globalParams.itemsView.tablet);
          }
        } else {
          this.setCookieItemsView(resultView);
        }
      } else {
        this.productsList = [];
        this.loadingProducts = false;
        this.controlPrice = 1;
      }
    }).catch(reason => {
      this.loadingProducts = false;
      this.localFilters = angular.copy(this.customFilters.attributes);
    });
    
  }
  
  activateProducts(item) {
    this.sliderOptions = {
      options : {
        showSelectionBar: true,
        selectionBarGradient: {
          from: this.ngAuthSettings.site.info.style.secondColor,
          to: this.ngAuthSettings.site.info.style.secondColor
        },
        getPointerColor: (value) => {
          return this.ngAuthSettings.site.info.style.mainColor;
        },
        floor: 0,
        step: 1,
        minRange: 10,
        ceil: item.productHighPrice,
        noSwitching: true,
        onEnd : (sliderId, modelValue, highValue) => {
          this.getProducts();
        },
        translate: (value) => {
          return (this.$filter('currency')(value, '$', 0));
        }
      }
    };
    this.$timeout(() => {
      this.$scope.$broadcast('rzSliderForceRender');
    }, 1000);
  };
  

  
  changeInternalWordSearch(){
    this.controlPrice = 0;
  }
  
  compareProductsSelected() {
    let keys = Object.keys(this.productsToCompare.items);
    this.$state.go('/products/compare/' + this.categoryId + '/' + keys.join('-'));
  }
  
  cleanFilters(){
    this.controlPrice = 0;
    this.getProducts(false, true);
  }
  
  setPagination (type, footer) {
    this.pageSize = type;
    this.getProducts(footer);
  }
  
  setSort (type, footer) {
    this.sortType = type;
    this.getProducts(footer);
  }
  
  setCookieItemsView (itemView) {
    itemView = parseInt(itemView);
    this.typeview = itemView;
    this.SessionService.put('itemsView', itemView);
  };
  
  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

SalesController.$inject = inject;

export default SalesController;




// WEBPACK FOOTER //
// ./www/components/catalog/sales/sales.controller.js